(function($) {
    setImgHeight = function(img) {
        var imageHeight = $(img).height();
        var imageElement = $(img);
        imageElement.css('height', imageHeight);
    };

    $(window).on('load resize orientationchange', function() {
        $('.image-absolute .bg-image').each(function() {
            var $img = $(this);
            setImgHeight($img);
        });
    });
})(jQuery);